import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BankDetails, BankDetailsClient, Kasa, KasaClient} from "src/app/web-api-client";
import { WtStorageService } from "../../../wt-storage.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { BankDetailsStatus } from "../../../enums/bankDetails.enum";

@Component({
  selector: 'app-bank-account-edit',
  templateUrl: './bank-account-edit.component.html',
  styleUrls: ['./bank-account-edit.component.scss']
})
export class BankAccountEditComponent implements OnInit  {

  public isLoaded = true;
  public selectedService: BankDetails;
  public onClose: Subject<void> = new Subject();

  public selectedStatus: BankDetailsStatus = BankDetailsStatus.Standard; // Default selection

  // Convert Enum to Array for *ngFor
  public statuses = Object.keys(BankDetailsStatus)
    .filter(key => !isNaN(Number(BankDetailsStatus[key])))
    .map(key => ({ name: key, value: BankDetailsStatus[key] }));

   Form: FormGroup;

  constructor(private fb: FormBuilder,public activeModal: NgbActiveModal,public wtStore:WtStorageService,public client:BankDetailsClient ) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    this.Form = this.fb.group({
      title: [this.selectedService.title, Validators.required],
      iban: [this.selectedService.iban, Validators.required],
      bic: [this.selectedService.bic, Validators.required],
      status: [this.selectedService.status, Validators.required],
    });
  }

  closeModal() {
    this.onClose.next();
    this.activeModal.close();
  }

  onSubmit() {
    if (this.Form.valid) {


      this.selectedService.title = this.Form.value.title;
      this.selectedService.iban = this.Form.value.iban;
      this.selectedService.bic = this.Form.value.bic;
      this.selectedService.status = this.selectedStatus;

      this.client.update(this.selectedService).subscribe((user)=>{

        this.onClose.next();
        this.activeModal.close();
      });
    }
  }

}
